module.exports = __webpack_public_path__ + "static/media/IMG_20250225_092435.0d89283b.webp";